import React from "react";
import { motion } from "framer-motion";
import { BookOpen } from "lucide-react";
import { SectionLabel } from "./SectionLabel";
import { PHASES, WEEKLY_FOCUS, fadeUp, stagger } from "./constants";

export default function EliteStructure() {
  return (
    <section className="py-24 md:py-32 bg-[#FEFDFB] text-[#0D1F17]" data-testid="program-structure">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <motion.div {...fadeUp} className="text-center mb-16">
          <SectionLabel>Program Structure</SectionLabel>
          <h2 className="font-serif text-3xl sm:text-4xl text-[#0D1F17] mt-4">The 12-Week Arc</h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
          {PHASES.map((phase, i) => (
            <motion.div key={phase.phase} {...stagger(i)} data-testid={`phase-${i}`}
              className="relative bg-white border border-[#0D1F17]/8 rounded-2xl p-6 shadow-sm overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-1" style={{ backgroundColor: phase.color }} />
              <span className="font-serif text-4xl font-bold" style={{ color: `${phase.color}30` }}>{phase.phase}</span>
              <h4 className="font-serif text-lg text-[#0D1F17] mt-2 mb-1">{phase.title}</h4>
              <p className="text-xs text-[#0D1F17]/40 uppercase tracking-wider mb-3">{phase.weeks}</p>
              <p className="text-sm text-[#0D1F17]/60 leading-relaxed">{phase.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div {...fadeUp} className="bg-white border border-[#0D1F17]/8 rounded-2xl overflow-hidden shadow-sm max-w-3xl mx-auto">
          <div className="px-6 py-5 border-b border-[#0D1F17]/5">
            <h4 className="font-serif text-lg text-[#0D1F17]">Weekly Focus Themes</h4>
            <p className="text-xs text-[#0D1F17]/40 mt-1">Each week builds one pillar of nutrition literacy</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-0 divide-y sm:divide-y-0 sm:divide-x divide-[#0D1F17]/5">
            {WEEKLY_FOCUS.map((w) => (
              <div key={w.week} className="flex items-center gap-3 px-5 py-3.5">
                <div className="w-7 h-7 rounded-lg bg-[#0D1F17]/5 flex items-center justify-center">
                  <w.icon size={13} className="text-[#0D1F17]/50" />
                </div>
                <div>
                  <span className="text-[10px] text-[#0D1F17]/30 uppercase tracking-wider">Wk {w.week}</span>
                  <p className="text-sm text-[#0D1F17]">{w.focus}</p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div {...fadeUp} className="mt-10 max-w-3xl mx-auto flex items-start gap-4 bg-[#D4AF37]/5 border border-[#D4AF37]/15 p-6 rounded-2xl">
          <BookOpen size={22} className="text-[#D4AF37] flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="font-serif text-base text-[#0D1F17] mb-1">Fitly Nutrition Guide</h4>
            <p className="text-sm text-[#0D1F17]/60">A comprehensive take-home resource covering all 12 weekly themes — yours to keep after the program.</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
